/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './infinite-select.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/components/infinite-select/infinite-select.component';
import * as i3 from '../../../../$$_gendir/node_modules/ng2-select2/ng2-select2.component.ngfactory';
import * as i4 from 'ng2-select2/ng2-select2.component';
import * as i5 from '@angular/common';
import * as i6 from 'ngx-toastr';
import * as i7 from 'ngx-bootstrap/modal/bs-modal.service';
const styles_InfiniteSelectComponent:any[] = [i0.styles];
export const RenderType_InfiniteSelectComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_InfiniteSelectComponent,data:{}});
function View_InfiniteSelectComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'loading-indicator']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['Loading...'])),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),
      (null as any));
}
export function View_InfiniteSelectComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{selectContainerRef:0}),(_l()(),i1.ɵeld(1,
      0,[[1,0],['selectContainer',1]],(null as any),7,'div',([] as any[]),(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n  '])),(_l()(),i1.ɵeld(3,0,(null as any),(null as any),1,'select2',
      ([] as any[]),(null as any),[[(null as any),'valueChanged']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.InfiniteSelectComponent = _v.component;
        if (('valueChanged' === en)) {
          const pd_0:any = ((<any>_co.oneValueChanged($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i3.View_Select2Component_0,i3.RenderType_Select2Component)),i1.ɵdid(4,4964352,
      (null as any),0,i4.Select2Component,[i1.Renderer],{data:[0,'data'],value:[1,
          'value'],width:[2,'width'],disabled:[3,'disabled'],options:[4,'options']},
      {valueChanged:'valueChanged'}),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InfiniteSelectComponent_1)),
      i1.ɵdid(7,16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.InfiniteSelectComponent = _v.component;
    const currVal_0:any = _co.options;
    const currVal_1:any = _co.value;
    const currVal_2:any = _co.width;
    const currVal_3:any = _co.disabled;
    const currVal_4:any = _co.Options.select2Options;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = _co.loading;
    _ck(_v,7,0,currVal_5);
  },(null as any));
}
export function View_InfiniteSelectComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'infinite-select',
      ([] as any[]),(null as any),(null as any),(null as any),View_InfiniteSelectComponent_0,
      RenderType_InfiniteSelectComponent)),i1.ɵdid(1,6537216,(null as any),0,i2.InfiniteSelectComponent,
      [i1.ChangeDetectorRef,i6.ToastrService,i7.BsModalService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const InfiniteSelectComponentNgFactory:i1.ComponentFactory<i2.InfiniteSelectComponent> = i1.ɵccf('infinite-select',
    i2.InfiniteSelectComponent,View_InfiniteSelectComponent_Host_0,{width:'width',
        disabled:'disabled',Options:'Options',value:'value'},{valueChanged:'valueChanged'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvY29tcG9uZW50cy9pbmZpbml0ZS1zZWxlY3QvaW5maW5pdGUtc2VsZWN0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2NvbXBvbmVudHMvaW5maW5pdGUtc2VsZWN0L2luZmluaXRlLXNlbGVjdC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2NvbXBvbmVudHMvaW5maW5pdGUtc2VsZWN0L2luZmluaXRlLXNlbGVjdC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvY29tcG9uZW50cy9pbmZpbml0ZS1zZWxlY3QvaW5maW5pdGUtc2VsZWN0LmNvbXBvbmVudC50cy5JbmZpbml0ZVNlbGVjdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgI3NlbGVjdENvbnRhaW5lcj5cbiAgPHNlbGVjdDJcbiAgICBbZGF0YV09XCJvcHRpb25zXCJcbiAgICBbdmFsdWVdPVwidmFsdWVcIlxuICAgIFt3aWR0aF09XCJ3aWR0aFwiXG4gICAgW2Rpc2FibGVkXT1cImRpc2FibGVkXCJcbiAgICBbb3B0aW9uc109XCJPcHRpb25zLnNlbGVjdDJPcHRpb25zXCJcbiAgICAodmFsdWVDaGFuZ2VkKT1cIm9uZVZhbHVlQ2hhbmdlZCgkZXZlbnQpXCJcbiAgPjwvc2VsZWN0Mj5cbiAgPGRpdiAqbmdJZj1cImxvYWRpbmdcIiBjbGFzcz1cImxvYWRpbmctaW5kaWNhdG9yXCI+XG4gICAgPHNwYW4+TG9hZGluZy4uLjwvc3Bhbj5cbiAgPC9kaXY+XG48L2Rpdj5cbiIsIjxpbmZpbml0ZS1zZWxlY3Q+PC9pbmZpbml0ZS1zZWxlY3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDU0U7TUFBQTtNQUFBLGdCQUErQyw4Q0FDN0M7TUFBQTtNQUFBLDRDQUFNO01BQUEsaUJBQWlCOzs7O2dFQVYzQjtNQUFBO01BQUEsMERBQXNCO01BQUEseUJBQ3BCO01BQUE7UUFBQTtRQUFBO1FBTUU7VUFBQTtVQUFBO1FBQUE7UUFORjtNQUFBLHFFQUFBO01BQUE7VUFBQTtNQUFBLCtCQU9XLDRDQUNYO2FBQUE7YUFBQTtVQUFBLGlDQUVNO01BQ0Y7O0lBVkY7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUxGLFdBQ0UsVUFDQSxVQUNBLFVBQ0EsVUFDQSxTQUxGO0lBUUs7SUFBTCxXQUFLLFNBQUw7Ozs7b0JDVEY7TUFBQTt3Q0FBQSxVQUFBO01BQUE7O1FBQUE7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/infinite-select/infinite-select.component.ngfactory.ts